import React from 'react';
import Layout from 'components/Layout';
import Page from 'components/Page';
import { getPrefix } from 'locales';

import privacyUa from './privacy.md';
import privacyRu from './privacy.ru.md';

function action({ intl }) {
  const privacy = getPrefix(intl.locale) === 'uk' ? privacyUa : privacyRu;
  return {
    chunks: ['site'],
    title: privacy.title,
    component: (
      <Layout>
        <Page {...privacy} />
      </Layout>
    ),
  };
}

export default action;
